import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

// components
import Widget from "app/static/frontend/widgets/components/Widget"

// selectors
import {
    selectWidgetHeaderTitle,
    selectWidgetKey,
} from "app/static/frontend/widgets/selectors/selectors"

const mapStateToProps = createStructuredSelector({
    headerTitle: selectWidgetHeaderTitle,
    widgetKey: selectWidgetKey,
})

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Widget)
